import { Column } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
import { ReasonsChecklist } from "./ReasonsChecklist";
export var TellUsMore = function TellUsMore(_ref) {
  var checkedReasons = _ref.checkedReasons,
    setCheckedReasons = _ref.setCheckedReasons;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(TellUsMoreTitle, null), /*#__PURE__*/React.createElement(ReasonsChecklist, {
    checked: checkedReasons,
    setChecked: setCheckedReasons
  }));
};
var TellUsMoreTitle = function TellUsMoreTitle() {
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium",
    style: {
      marginTop: getSpacing("4x")
    }
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "HmkVcl",
    defaultMessage: [{
      "type": 0,
      "value": "Aidez-nous à nous améliorer en sélectionnant toutes les réponses qui s'appliquent :"
    }]
  }));
};
var Wrapper = styled(Column).attrs({
  gap: "1x"
}).withConfig({
  displayName: "TellUsMore__Wrapper"
})([""]);